module.exports = __webpack_public_path__ + "static/media/grape.51ea8bec.png";